module.exports = __webpack_public_path__ + "img/ab-img.8d7ae5ac.png";